/**
 * Listings limits the API enforces and the web forms check first (CONFIG
 * CF-6, moved from both sides unchanged). Character counts, except where a
 * name says days, hours or items.
 */
/**
 * PUT /api/listings/settings and the listings.compliance settings
 * (settings/groups/listings.ts). The bounds the `listing_settings` table's
 * CHECKs enforced until CF-14 dropped it; tests/limits.test.ts pins them to
 * the migration that created it.
 */
export const LISTING_COMPLIANCE_LIMITS = {
    expiryWarningDays: { min: 1, max: 365 },
    takedownWindowHours: { min: 1, max: 720 },
};
/** Task templates: at most this many steps, and a due offset of 0 to this many days. */
export const LISTING_TEMPLATE_LIMITS = {
    steps: 20,
    dueOffsetDays: 365,
};
/** Listing platforms and their fields (Settings → Listing task templates → Listing platforms). */
export const LISTING_PLATFORM_LIMITS = {
    name: 100,
    fieldLabel: 200,
    helpText: 1000,
};
/** A listing's marketing (headline, description, highlights) and a post's note. */
export const LISTING_MARKETING_LIMITS = {
    headline: 300,
    description: 20_000,
    /** Items, each at most `highlight` characters. */
    highlights: 20,
    highlight: 300,
    postNote: 2000,
};
//# sourceMappingURL=listings.js.map